import { HTMLAttributes, createElement, forwardRef } from "react";

type EditorRootProps = HTMLAttributes<HTMLDivElement>;

export const EditorRoot = forwardRef<HTMLDivElement, EditorRootProps>(function EditorRoot(props, ref) {
  return createElement("div", { ...props, ref }, props.children);
});
